


import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import MapObject, {MapObjectImage} from '@/interfaces/entities/map-object.interface';
import {MediaQueryService} from '@/services/media-query.service';
import MapFeaturesService from '@/services/map-features.service';

@Component({})
export default class AppMapListObject extends Vue {

  @Prop()
  object!: MapObject;

  @Emit('select')
  public emitSelect(): MapObject {
    return this.object;
  }

  @Watch('object', {immediate: true})
  public objectChange(): void {
    this.objectUniqueKey = this.object.id + '-' + new Date().getTime();
    this.updatePreviewImage();
  }

  public objectUniqueKey: string = '';
  public previewImage: string | null = null;
  public mediaQueryService: MediaQueryService = MediaQueryService.getInstance();
  private mapFeaturesService: MapFeaturesService = MapFeaturesService.getInstance();
  private defaultPreviewImage: string = '/themes/28-mammadaba-modern/images/image-placeholder.svg';

  constructor() {
    super();
  }

  public mounted(): void {
  }

  public select(): void {
    this.emitSelect();
  }

  public fetchImages(): void {
    if (!this.object.images) {
      this.mapFeaturesService.mapObjectImages(this.object).subscribe(images => {
        this.object.images = images;
        this.updatePreviewImage();
      });
    }
  }

  public updatePreviewImage(): void {
    const firstImage: MapObjectImage | null = this.object.images ? this.object.images[0] : null;
    this.previewImage = firstImage ? firstImage.thumbnail : this.defaultPreviewImage;
  }
}
